import { render, staticRenderFns } from "./menuContent.vue?vue&type=template&id=439f3a3e&scoped=true"
import script from "./menuContent.vue?vue&type=script&lang=js"
export * from "./menuContent.vue?vue&type=script&lang=js"
import style0 from "./menuContent.vue?vue&type=style&index=0&id=439f3a3e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439f3a3e",
  null
  
)

export default component.exports